import { useAtomValue } from "jotai";
import { useState } from "react";

import { getMemberBookingRoundsAtom } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/atoms/selectors/getBookingRounds/getBookingMemberRounds";
import { getHostIdAtom } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/atoms/selectors/getHostIdAtom/getHostIdAtom";
import { EditIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  HStack,
  Box,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { getRoundFromIdAtom } from "../../../../../../../atoms/selectors/getRoundFromIdAtom/getRoundFromIdAtom";
import { GuestRoundHostRateDisplay } from "./GuestRoundHostRateDisplay";
import { GuestRoundHostRateEdit } from "./GuestRoundHostRateEdit";

type Props = {
  roundId: string;
};
export const GuestRoundHostRate = ({ roundId }: Props) => {
  const [isEditing, setIsEditing] = useState(false);

  const round = useAtomValue(getRoundFromIdAtom(roundId));
  const bookingPlayers = useAtomValue(getMemberBookingRoundsAtom);
  const hostId = useAtomValue(getHostIdAtom(roundId));

  const currentHost = bookingPlayers?.find((p) => p.player.id === hostId);

  const isGuestRound =
    round?.player?.clientType === "guest" ||
    round?.player?.clientType === "unknownGuest" ||
    round?.player?.clientType === "newGuest";

  return (
    <>
      {isGuestRound ? (
        <HStack justifyContent="space-between" alignItems="center">
          {isEditing ? (
            <GuestRoundHostRateEdit
              roundId={roundId}
              nonPlayingHost={currentHost?.isNonPlayingHost || false}
              membershipTypeId={
                currentHost?.player && "membershipTypeId" in currentHost.player
                  ? currentHost.player.membershipTypeId
                  : undefined
              }
            />
          ) : (
            <GuestRoundHostRateDisplay
              roundId={roundId}
              membershipTypeId={
                currentHost?.player && "membershipTypeId" in currentHost.player
                  ? currentHost.player.membershipTypeId
                  : undefined
              }
              nonPlayingHost={currentHost?.isNonPlayingHost || false}
              hostId={hostId ?? ""}
            />
          )}

          {!isEditing && (
            <Box
              width={32}
              height={32}
              borderRadius="2"
              borderWidth={1.5}
              borderColor="outline-default"
              justifyContent="center"
              alignItems="center"
              marginLeft={2}
            >
              <Pressable onPress={() => setIsEditing(!isEditing)}>
                <EditIcon />
              </Pressable>
            </Box>
          )}
        </HStack>
      ) : null}
    </>
  );
};
